import React from "react";
import Banner from "../../components/banner";
import Reserve from "../../components/reserve";
import Typography from "@material-ui/core/Typography";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import LocationIcon from "@material-ui/icons/LocationOnOutlined";
import PhoneIcon from "@material-ui/icons/PhoneOutlined";
import Footer from "../../components/Footer";
import Dialog from "@material-ui/core/Dialog";
import FailedPage from "../../components/PaymentStatus/Failed";
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";
import FillForm from "../../components/PaymentStatus/FillForm";
import "../galleryStyles.scss";
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@material-ui/core";
import axios from "axios";
import HttpModule from "../../services/http.module";
import PollingPage from "../polling";

const Title = (props) => (
  <div className="col-12 text-center p-3 display-4 text-muted mb-3">
    {props.children}
  </div>
);

export class HomePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: 0,
      step: 0,
      ComponentData: {},
      payment: undefined,
      DialogStatus: false,
      price: "0",
      trackCode: "",
      ridmooniDialog: false,
      IdCode: "",
      UserName: "",
      PhoneNumber: "",
      message: "",
    };

    var url = new URLSearchParams(window.location.search);

    if (url.get("update_data")?.toString() === "1") {
      this.state.ridmooniDialog = true;
    } else if (this.props.match.params.paymentStatus === "1") {
      this.state.payment = true;
      const { price, trackCode } = this.props.match.params;

      if (!price) this.state.payment = undefined;
      else this.state.price = price;

      if (!trackCode) this.state.payment = undefined;
      else this.state.trackCode = trackCode;
    } else if (typeof this.props.match.params.paymentStatus !== "undefined") {
      this.state.payment = false;
      const { price, trackCode } = this.props.match.params;

      if (!price) this.state.payment = undefined;
      else this.state.price = price;

      if (!trackCode) this.state.payment = undefined;
      else this.state.trackCode = trackCode;
    } else {
      this.state.payment = undefined;
    }
  }

  componentDidMount() {
    if (this.state.payment !== undefined)
      this.setState({
        DialogStatus: true,
      });
  }

  OnClose = () => {
    this.setState({
      DialogStatus: false,
    });
  };

  ChangeRoute = () => {
    this.setState(
      {
        DialogStatus: false,
      },
      () => {
        this.props.history.push(
          `/refrandom/${this.props.match.params.paymentStatus}/${this.props.match.params.price}/${this.props.match.params.trackCode}`
        );
      }
    );
  };

  render() {
    return (
      <>
        <div className="row fadeUpAn">
          <Banner classes="p-2" />
        </div>
        <div className="row my-5">
          <div className="col-12">
            <PollingPage />
          </div>
        </div>
        <div className="row my-3">
          <Title align="center">کیدز کلاب</Title>
          <div className="col-12">
            <Typography variant={"h6"} align={"center"}>
              برای ثبت نام در کیدز کلاب{" "}
              <a href="https://user.goftegooclub.ir">اینجا</a> کلیک کنید
            </Typography>
          </div>
        </div>
        <div className="row">
          <Title>تست ها</Title>
          <Card className="col-lg-8 mr-auto ml-auto shadow-sm rounded-lg ">
            <CardContent>
              <div className="row">
                {/* <div className="col-md-5 shadow-lg rounded">
                  <Typography variant="h5" align="center" className="p-3">
                    پرسشنامه کودک
                  </Typography>
                  <Typography align="center">
                    با شرکت کردن در پرسشنامه کودک مارا از عملکرد خود با خبر
                    سازید
                  </Typography>
                  <div className="row p-3 text-center">
                    <div className="col-12 text-center">
                      <Button
                        color={"secondary"}
                        variant="outlined"
                        onClick={() => {
                          // window.location.href = "http://goftegooclub.ir";
                          this.props.history.push("/refrandom");
                        }}
                        className="font-weight-bold shadow"
                      >
                        شرکت در پرسشنامه کودک
                      </Button>
                    </div>
                  </div>
                </div> */}
                {/* <div className="col-1"></div> */}
                <div className="col-md-5 shadow-lg rounded">
                  <Typography variant="h5" align="center" className="p-3">
                    تست شخصیت شناسی MBTI
                  </Typography>
                  <Typography align="center">
                    با شرکت کردن در تست شخصیت شناسی از نوع شخصیت خود با خبر شوید
                  </Typography>
                  <div className="row p-3 text-center">
                    <div className="col-12 text-center">
                      <Button
                        color={"secondary"}
                        variant="outlined"
                        onClick={() => {
                          // window.location.href = "http://goftegooclub.ir";
                          this.props.history.push("/mbti");
                        }}
                        className="font-weight-bold shadow"
                      >
                        شرکت در تست MBTI
                      </Button>
                    </div>
                  </div>
                </div>
                <div className="col-md-6"></div>
              </div>

              {/* <div className="row">
                <div className="col-md-5 mt-3 shadow-lg rounded">
                  <Typography variant="h5" align="center" className="p-3">
                    پرسشنامه علاقه اجتماعی کودکان
                  </Typography>
                  <Typography align="center"></Typography>
                  <div className="row p-3 text-center">
                    <div className="col-12 text-center">
                      <Button
                        color={"secondary"}
                        variant="outlined"
                        onClick={() => {
                          // window.location.href = "http://goftegooclub.ir";
                          this.props.history.push("/new_test");
                        }}
                        className="font-weight-bold shadow"
                      >
                        پرسشنامه علاقه اجتماعی کودکان
                      </Button>
                    </div>
                  </div>
                </div>
              </div> */}
            </CardContent>
          </Card>
        </div>
        <div className="row">
          <Title>تماس با ما</Title>
          <Card className="col-lg-8 mr-auto ml-auto shadow-sm rounded-lg ">
            <CardContent>
              <Typography variant="body2" className="text-center rtl">
                <LocationIcon />
                آدرس : قدوسی غربی ، نبش کوچه ۶ علیرضایی ، کلاب
                کودک گفتگو
              </Typography>
              <Typography variant="body2" className="text-center rtl mt-3">
                <PhoneIcon /> تلفن تماس : ۰۹۱۷۰۷۲۱۳۴۲
              </Typography>
            </CardContent>
          </Card>
        </div>

        <Dialog
          open={this.state.DialogStatus}
          onClose={this.state.payment ? this.ChangeRoute : this.OnClose}
          fullWidth
        >
          {this.state.payment !== undefined ? (
            this.state.payment ? (
              <FillForm
                Close={this.ChangeRoute}
                track={this.state.trackCode}
                price={this.state.price}
              />
            ) : (
              <FailedPage
                Close={this.OnClose}
                track={this.state.trackCode}
                price={this.state.price}
              />
            )
          ) : (
            <> </>
          )}
        </Dialog>

        <Dialog open={this.state.ridmooniDialog} onClose={() => {}} fullWidth>
          <DialogTitle>ثبت اطلاعات</DialogTitle>
          <DialogContent>
            <div className="row">
              <div className="col-12 p-3">
                <TextField
                  label={"نام و نام خانوادگی"}
                  variant="outlined"
                  color="primary"
                  fullWidth
                  onChange={(e) => {
                    this.setState({
                      UserName: e.target.value,
                    });
                  }}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12 p-3">
                <TextField
                  label={"کد ملی"}
                  variant="outlined"
                  color="primary"
                  fullWidth
                  onChange={(e) => {
                    this.setState({
                      IdCode: e.target.value,
                    });
                  }}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-12 p-3">
                <TextField
                  label={"شماره تماس"}
                  variant="outlined"
                  color="primary"
                  fullWidth
                  onChange={(e) => {
                    this.setState({
                      PhoneNumber: e.target.value,
                    });
                  }}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-12 text-danger">{this.state.message}</div>
            </div>
          </DialogContent>

          <DialogActions>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={() => {
                if (
                  !this.state.IdCode ||
                  !this.state.PhoneNumber ||
                  !this.state.UserName
                ) {
                  this.setState(
                    {
                      message: "لطفا تمامی فیلد ها را پر کنید",
                    },
                    () => {
                      setTimeout(() => {
                        this.setState({
                          message: "",
                        });
                      }, 5000);
                    }
                  );
                  return;
                }
                HttpModule.UpdateData({
                  IdCode: this.state.IdCode,
                  PhoneNumber: this.state.PhoneNumber,
                  UserName: this.state.UserName,
                })
                  .then((_) => {
                    this.setState({
                      ridmooniDialog: false,
                    });
                  })
                  .catch((e) => {
                    this.setState({
                      message: "خطا در ثبت اطلاعات لطفا دوباره تلاش کنید",
                    });
                  });
              }}
            >
              ثبت
            </Button>
          </DialogActions>
        </Dialog>

        <Footer />
      </>
    );
  }
}

export default HomePage;
